import React from "react";
import { useParams } from "react-router-dom";

import {
    Box,
    Typography,
    Grid,
    Divider,
} from "@mui/material";

import DetailsView from "../Common/Views/DetailsView";
import ListView from "../Common/Views/ListView";

function CustomerDataLayout({ data }) {
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} lg={4}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Name
                    </Typography>
                    <Typography variant="body2">{data.name || "-"}</Typography>
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Email
                    </Typography>
                    <Typography variant="body2">{data.email || "-"}</Typography>
                </Grid>

                <Grid item xs={12} sm={6} lg={4}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Phone Number
                    </Typography>
                    <Typography variant="body2">{data.phoneNumber || "-"}</Typography>
                </Grid>

            </Grid>

            <Divider />
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Address
                    </Typography>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                        {data.address || "-"}
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" color="text.secondary">
                        Additional information
                    </Typography>
                    <Typography variant="body2" sx={{ whiteSpace: 'pre-line' }}>
                        {data.additionalInfo || "-"}
                    </Typography>
                </Grid>
            </Grid>

        </>
    );
}


export default function CustomerDetails() {
    const { id } = useParams();

    return (
        <>
            <DetailsView
                title="Customer details"
                subtitleAttribute="name"
                apiPath={`/tenants/customers/${id}`}
                editPath={`/customers/${id}/edit`}
                onDelete={(data) => {
                    console.log("Delete action for", data);
                    // you can plug delete API call here
                }}
            >
                {({ data }) => <CustomerDataLayout data={data} />}
            </DetailsView>


            {/* This is not the general Vehicles List. We call the /customers/:id/vehicles endpoint */}
            <Box margin={{ xs: 1, sm: 2 }} mt={{ xs: 2, sm: 4 }} padding={{ xs: 1, sm: 2 }}>
                <ListView
                    title="Owned vehicles"
                    apiPath={`/tenants/customers/${id}/vehicles`}
                    addButton={true}
                    addButtonLabel="Add new vehicle"
                    addPath="/vehicles/add"
                    rowClickPath={(vehicle) => `/vehicles/${vehicle.id}`}
                    columnsConfig={{
                        registrationNumber: {
                            key: 'registrationNumber',
                            label: 'Registration number',
                            render: row => row.registrationNumber
                        },
                        make: {
                            key: 'make',
                            label: 'Make',
                            render: row => row.make
                        },
                        model: {
                            key: 'model',
                            label: 'Model',
                            render: row => row.model
                        },
                        year: {
                            key: 'year',
                            label: 'Year',
                            render: row => row.year
                        },
                        isActive: {
                            key: 'isActive',
                            label: 'Active',
                            render: row => row.isActive ? 'Yes' : 'No'
                        },
                    }}
                    searchBox={false}
                    searchAttributes={[
                        { name: "registrationNumber", label: "Registration number", type: "text" },
                    ]}
                    noResultsMessage="No vehicles found"
                />
            </Box>


        </>
    )
};